export default "__VITE_ASSET__DiD57wk7__"